import React from 'react';
import { Box, Paper, Typography, Button, IconButton } from '@mui/material';
import { ChatBubble, Close } from '@mui/icons-material';

const ChatModal = ({ open, onClose, onOpenChat }) => {
  if (!open) return null;

  return (
    <Box sx={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.4)', zIndex: 9999,
      display: 'flex', justifyContent: 'center', alignItems: 'center', px: 2
    }}>
      <Paper sx={{ 
        padding: '24px 20px', width: '100%', maxWidth: 340, textAlign: 'center', 
        borderRadius: '16px', position: 'relative', boxShadow: '0px 4px 20px rgba(0,0,0,0.15)' 
      }}>
        
        <IconButton onClick={onClose} sx={{ position: 'absolute', top: 8, right: 8, color: '#999' }}>
          <Close />
        </IconButton>

        {/* Icon Area */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <Box sx={{ 
            width: 64, height: 64, borderRadius: '50%', backgroundColor: '#FFF0E5', 
            display: 'flex', justifyContent: 'center', alignItems: 'center' 
          }}>
            <ChatBubble sx={{ color: '#5C3016', fontSize: 32 }} />
          </Box>
        </Box>

        {/* Text Area */}
        <Typography variant="h6" sx={{ fontWeight: 700, color: '#333', mb: 1 }}>
          Your Details Have Been Shared
        </Typography>
        <Typography variant="body2" sx={{ color: '#666', mb: 3 }}>
          Your contact details have been sent to the owner. You can now chat with them.
        </Typography>

        {/* Action Button */}
        <Button 
          fullWidth 
          variant="contained" 
          onClick={onOpenChat}
          startIcon={<ChatBubble sx={{ fontSize: 20 }} />}
          sx={{ 
            backgroundColor: '#7F3F14', // Matches the brown from your screenshot
            color: '#fff', 
            borderRadius: '8px', 
            textTransform: 'none', 
            fontSize: '16px', 
            fontWeight: 600, 
            py: 1.2, 
            '&:hover': { backgroundColor: '#5C3016' } 
          }}
        >
          Open Chat
        </Button>
      </Paper>
    </Box>
  );
};

export default ChatModal;